import React, { useEffect, useState } from "react";
import { useRouter } from "@contexts/RouterProvider";
import ReportsMenu from "./ReportsMenu";
import MainMenu from "./MainMenu";
import ClimateReport from "../reports/ClimateReport";
import SatelliteImageReport from "../reports/SatelliteImageReport";
import IrrigationReport from "../reports/IrrigationReport";


const RouterOutlet = ({ resources, classes }) => {
  const { baseURL } = useRouter();

  const [path, setPath] = useState(() => {
    return window.location.pathname.replace(baseURL, "");
  });

  useEffect(() => {
    const onPopState = () => {
      const newPath = window.location.pathname.replace(baseURL, "");
      setPath(newPath);
    };

    window.addEventListener("popstate", onPopState);

    return () => {
      window.removeEventListener("popstate", onPopState);
    };
  }, [baseURL]);

  if (path === "admin/reports") return <ReportsMenu classes={classes} />;
  if (path === "admin/reports/climate") return <ClimateReport classes={classes} />;
  if (path === "admin/reports/irrigation") return <IrrigationReport classes={classes} />;
  if (path === "admin/reports/ndvi") return <SatelliteImageReport classes={classes} />;

  return <MainMenu resources={resources} classes={classes} />;
};

export default RouterOutlet;
